import React, { Component } from 'react'
import { Flex, Box, Text, Divider, Relative, Button } from 'rebass'
import styled from 'styled-components'
import { Carousel } from 'react-responsive-carousel'
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'
import Container from '../../elements/Container'
import Title from '../../elements/Text/Title'
import { colors, fonts, fontSizes } from '../../theme'
import {
  CashMultipleIcon,
  IncognitoIcon,
  AccountCardDetailsIcon,
} from 'mdi-react'
import Link from 'gatsby-link'

const ServiceContainer = styled(Flex)`
  background-color: ${colors.white};
  border: 1px solid ${colors.grey};
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  height: 100%;
  border-radius: 10px;
  position: relative;
  &:hover {
    background-image: url('/img/background.jpg');
    &:before {
      background-color: rgba(1, 47, 92, 0.9);
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      content: '';
    }
  }
`
const IconContainer = styled(Box)`
  color: ${colors.secondary};
  background-color: ${colors.primary};
  margin: 2rem;
  padding: 1.5rem;
  border-radius: 50%;
  display: inline-block;
`
const ServiceTitle = styled(Text)`
  font-family: ${fonts.primary};
  color: ${colors.primary};
  font-weight: 700;
  font-size: ${fontSizes[3] + 'px'};
  line-height: 1.1;
  ${ServiceContainer}:hover & {
    color: white;
  }
`
const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  margin-bottom: 2rem;
  display: inline-block;
`
const TextSeparator1 = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  margin-bottom: 2rem;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`
const ServiceDetails = styled.ul`
  list-style: disc;
  text-align: center;
  padding-left: 10px;
  color: ${colors.greyDark};
  font-family: ${fonts.secondary};
  ${ServiceContainer}:hover & {
    color: white;
  }
`
const Links = styled(Button)`
  color: ${colors.primary};
  font-family: ${fonts.primary};
  font-weight: 700;
  font-size: ${fontSizes[2] + 'px'};
  text-decoration: none;
  margin-top: 2rem;
  cursor: pointer;
  margin-bottom: 2rem;
  ${ServiceContainer}:hover & {
    color: ${colors.secondary};
  }
`
const OnlyLargeScreenBox = styled(Box)`
  @media (max-width: 48em) {
    display: none;
  }
`
const OnlySmallScreenBox = styled(Box)`
  max-width: 100vw;
  background-color: #fff;
  @media (min-width: 48em) {
    display: none;
  }
`

class Services extends Component {
  state = {
    read: 0,
    selectedItem: 0,
  }
  handleread = no => {
    this.setState({
      read: no,
    })
  }
  render() {
    return (
      <Box id="services">
        <Box px={[2, 3, 4, 5]} py={[3, , 5]} style={{ textAlign: 'center' }}>
          <Title color={colors.primary} fontSize={fontSizes[5] + 'px'}>
            Our Services<br />
          </Title>
          <TextSeparator1 />

          <OnlyLargeScreenBox>
            <Carousel
              showArrows={true}
              showThumbs={false}
              showStatus={false}
              infiniteLoop={true}
              autoPlay={false}
              interval={8000}
              transitionTime={800}
              selectedItem={this.state.selectedItem}
              onClickItem={(n) => this.setState({selectedItem: n})}
            >
              <div style={{ backgroundColor: colors.white }}>
                <Flex w={1} flexWrap="wrap">
                  <Box px={[3]} my={2} w={[1, 1, 1 / 2, 1 / 3]}>
                    <ServiceContainer>
                      {this.state.read !== 1 ? (
                        <Relative>
                          <IconContainer>
                            <CashMultipleIcon
                              style={{ width: '30px', height: '30px' }}
                            />
                          </IconContainer>
                          <ServiceTitle>Direct Taxation</ServiceTitle>
                          <TextSeparator />
                          <ServiceDetails>
                            International Tax structuring and compliance Direct
                            tax compliance <br />
                            <br />
                            <br />
                            <br />
                            <Links onClick={() => this.handleread(1)}>
                              {' '}
                              Read More
                            </Links>
                          </ServiceDetails>
                        </Relative>
                      ) : (
                        <Relative>
                          <Box textalign="center">
                            <ServiceDetails style={{ textAlign: 'left' }}>
                              <li>
                                {' '}
                                Compliances - Preparation & filing of Income Tax
                                Return, TDS Return, Tax Audit , preparation &
                                filing of Transfer pricing report
                              </li>
                              <li>
                                {' '}
                                Advisory to client on timely basis in their
                                complex issues pertaining to direct taxation
                                matter
                              </li>
                              <li>
                                {' '}
                                Litigation - Representation clients before
                                various tax authorities in various matters at
                                different levels such as assessments, appeals
                              </li>
                            </ServiceDetails>
                            <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                          </Box>
                        </Relative>
                      )}
                    </ServiceContainer>
                  </Box>
                  <Box px={[3]} my={2} w={[1, 1, 1 / 2, 1 / 3]}>
                    <ServiceContainer>
                      {this.state.read !== 2 ? (
                        <Relative>
                          <IconContainer>
                            <IncognitoIcon
                              style={{ width: '30px', height: '30px' }}
                            />
                          </IconContainer>
                          <ServiceTitle> Indirect Taxation - GST</ServiceTitle>
                          <TextSeparator />
                          <ServiceDetails>
                            Compliances - GST registration, Preparation & filing
                            of GST return of various dealers involving regular
                            dealers, composite dealers, ISD, TDS & TCS
                            deductors, casual dealers etc.<br />
                          </ServiceDetails>
                          <Links onClick={() => this.handleread(2)}>
                            {' '}
                            Read More
                          </Links>
                        </Relative>
                      ) : (
                        <Relative>
                          <Box textalign="center">
                            <ServiceDetails style={{ textAlign: 'left' }}>
                              <li>
                                Advisory - The firm is providing advisory to
                                various industry in order to make GST simple for
                                them. The firm is engaged in providing advisory
                                in respect GST impact on their complete supply
                                chain i.e from stage of procurement to stage of
                                supply. The firm is providing support to clients
                                in obtaining GST refund arising on account of
                                excess cash ledger balance, exports, inverted
                                duty structure, budgetary support scheme etc.
                              </li>
                            </ServiceDetails>
                            <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                          </Box>
                        </Relative>
                      )}
                    </ServiceContainer>
                  </Box>
                  <Box px={[3]} my={2} w={[1, 1, 1 / 2, 1 / 3]}>
                    <ServiceContainer>
                      {this.state.read !== 3 ? (
                        <Relative>
                          <IconContainer>
                            <AccountCardDetailsIcon
                              style={{ width: '30px', height: '30px' }}
                            />
                          </IconContainer>
                          <ServiceTitle> Accounting & Auditing</ServiceTitle>
                          <TextSeparator />
                          <ServiceDetails>
                            Statutory and Internal Audit Audit under IFRS,
                            US-GAAP and Indian GAAP and Bookkeeping<br />
                            <br />
                            <br />
                          </ServiceDetails>
                          <Links onClick={() => this.handleread(3)}>
                            {' '}
                            Read More
                          </Links>
                        </Relative>
                      ) : (
                        <Relative>
                          <Box textalign="center">
                            <ServiceDetails style={{ textAlign: 'left' }}>
                              <li>Statutory and Internal Audit</li>
                              <li>Audit under IFRS, US-GAAP and Indian GAAP</li>
                              <li>
                                Bookkeeping (including payroll accounting)
                              </li>
                              <li>IFRS/US-GAAP accounting services</li>
                              <li>
                                Preparation of annual/consolidated financial
                                statements
                              </li>
                            </ServiceDetails>
                            <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                          </Box>
                        </Relative>
                      )}
                    </ServiceContainer>
                  </Box>
                </Flex>
              </div>
              <div style={{ backgroundColor: colors.white, height: '100%' }}>
                <Flex w={1} flexWrap="wrap">
                  <Box px={[3]} my={2} w={[1, 1, 1 / 2, 1 / 3]}>
                    <ServiceContainer>
                      {this.state.read !== 4 ? (
                        <Relative>
                          <IconContainer>
                            <CashMultipleIcon
                              style={{ width: '30px', height: '30px' }}
                            />
                          </IconContainer>
                          <ServiceTitle>Guiding & Advisory</ServiceTitle>
                          <TextSeparator />
                          <ServiceDetails>
                            Guiding foreign companies in setting up their
                            business in India<br />
                            <br />
                            <br />
                            <br />
                          </ServiceDetails>
                          <Links onClick={() => this.handleread(4)}>
                            {' '}
                            Read More
                          </Links>
                        </Relative>
                      ) : (
                        <Relative>
                          <Box textalign="center">
                            <ServiceDetails style={{ textAlign: 'left' }}>
                              <li>
                                Guiding foreign companies willing to set up
                                their business in India in the following forms
                                :-
                              </li>
                              <li>100% wholly owned subsidiary</li>
                              <li>Liason office</li>
                              <li> Branch office</li>
                              <li> Project Office</li>
                              <li> Obtaining approvals from RBI</li>
                            </ServiceDetails>
                            <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                          </Box>
                        </Relative>
                      )}
                    </ServiceContainer>
                  </Box>
                  <Box px={[3]} my={2} w={[1, 1, 1 / 2, 1 / 3]}>
                    <ServiceContainer>
                      {this.state.read !== 5 ? (
                        <Relative>
                          <IconContainer>
                            <IncognitoIcon
                              style={{ width: '30px', height: '30px' }}
                            />
                          </IconContainer>
                          <ServiceTitle>Other Services</ServiceTitle>
                          <TextSeparator />
                          <ServiceDetails>
                            Some other services offered by the company are as
                            follows:-<br />
                            <br />
                            <br />
                            <br />
                          </ServiceDetails>
                          <Links onClick={() => this.handleread(5)}>
                            {' '}
                            Read More
                          </Links>
                        </Relative>
                      ) : (
                        <Relative>
                          <Box textalign="center">
                            <ServiceDetails style={{ textAlign: 'left' }}>
                              <li>Payroll Services - ESI & PF</li>
                              <li> Certification Services</li>
                              <li> ROC Complinaces</li>
                              <li> Maintaining Internal Controls</li>
                              <li> Management Consultancy</li>
                            </ServiceDetails>
                            <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                          </Box>
                        </Relative>
                      )}
                    </ServiceContainer>
                  </Box>
                  <Box px={[3]} my={2} w={[1, 1, 1 / 2, 1 / 3]}>
                    <ServiceContainer>
                      {this.state.read !== 6 ? (
                        <Relative>
                          <IconContainer>
                            <AccountCardDetailsIcon
                              style={{ width: '30px', height: '30px' }}
                            />
                          </IconContainer>
                          <ServiceTitle>
                            Financial Advisory Services
                          </ServiceTitle>
                          <TextSeparator />
                          <ServiceDetails>
                            Assistance in evaluation of financial implications
                            of proposed transactions.<br />
                            <br />
                            <br />
                            <br />
                          </ServiceDetails>
                          <Links onClick={() => this.handleread(6)}>
                            {' '}
                            Read More
                          </Links>
                        </Relative>
                      ) : (
                        <Relative>
                          <Box textalign="center">
                            <ServiceDetails style={{ textAlign: 'left' }}>
                              <li>
                                Assistance in evaluation of financial
                                implications of proposed transactions, including
                                tax optimisation of financing structures
                              </li>
                              <li>Conducting Business Valuations</li>
                              <li>
                                Advice to local/foreign private equity funds
                              </li>
                            </ServiceDetails>
                            <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                          </Box>
                        </Relative>
                      )}
                    </ServiceContainer>
                  </Box>
                </Flex>
              </div>
            </Carousel>
          </OnlyLargeScreenBox>
        </Box>

        <OnlySmallScreenBox>
          <Carousel
            showArrows={true}
            showThumbs={false}
            showStatus={false}
            infiniteLoop={true}
            autoPlay={false}
            interval={8000}
            transitionTime={800}
            selectedItem={this.state.selectedItem}
            onClickItem={(n) => this.setState({selectedItem: n})}
          >
            <div style={{ backgroundColor: colors.white, height: '100%' }}>
              <Box px={[3]} my={2} w={[1]}>
                <ServiceContainer>
                  {this.state.read !== 1 ? (
                    <Relative>
                      <IconContainer>
                        <CashMultipleIcon
                          style={{ width: '30px', height: '30px' }}
                        />
                      </IconContainer>
                      <ServiceTitle>Direct Taxation</ServiceTitle>
                      <TextSeparator />
                      <ServiceDetails>
                        International Tax structuring and compliance Direct tax
                        compliance <br />
                        <br />
                        <br />
                        <br />
                        <Links onClick={() => this.handleread(1)}>
                          {' '}
                          Read More
                        </Links>
                      </ServiceDetails>
                    </Relative>
                  ) : (
                    <Relative>
                      <Box textalign="center">
                        <ServiceDetails style={{ textAlign: 'left' }}>
                          <li>
                            {' '}
                            Compliances - Preparation & filing of Income Tax
                            Return, TDS Return, Tax Audit , preparation & filing
                            of Transfer pricing report
                          </li>
                          <li>
                            {' '}
                            Advisory to client on timely basis in their complex
                            issues pertaining to direct taxation matter
                          </li>
                          <li>
                            {' '}
                            Litigation - Representation clients before various
                            tax authorities in various matters at different
                            levels such as assessments, appeals
                          </li>
                        </ServiceDetails>
                        <Links onClick={() => this.handleread(0)}>
                          {' '}
                          Go back
                        </Links>
                      </Box>
                    </Relative>
                  )}
                </ServiceContainer>
              </Box>
            </div>
            <div style={{ backgroundColor: colors.white, height: '100%' }}>
              <Box px={[3]} my={2} w={[1]}>
                <ServiceContainer>
                  {this.state.read !== 2 ? (
                    <Relative>
                      <IconContainer>
                        <IncognitoIcon
                          style={{ width: '30px', height: '30px' }}
                        />
                      </IconContainer>
                      <ServiceTitle> Indirect Taxation - GST</ServiceTitle>
                      <TextSeparator />
                      <ServiceDetails>
                        Compliances - GST registration, Preparation & filing of
                        GST return of various dealers involving regular dealers,
                        composite dealers, ISD, TDS & TCS deductors, casual
                        dealers etc.<br />
                      </ServiceDetails>
                      <Links onClick={() => this.handleread(2)}>
                        {' '}
                        Read More
                      </Links>
                    </Relative>
                  ) : (
                    <Relative>
                      <Box textalign="center">
                        <ServiceDetails style={{ textAlign: 'left' }}>
                          <li>
                            Advisory - The firm is providing advisory to various
                            industry in order to make GST simple for them. The
                            firm is engaged in providing advisory in respect GST
                            impact on their complete supply chain i.e from stage
                            of procurement to stage of supply. The firm is
                            providing support to clients in obtaining GST refund
                            arising on account of excess cash ledger balance,
                            exports, inverted duty structure, budgetary support
                            scheme etc.
                          </li>
                        </ServiceDetails>
                        <Links onClick={() => this.handleread(0)}>
                          {' '}
                          Go back
                        </Links>
                      </Box>
                    </Relative>
                  )}
                </ServiceContainer>
              </Box>
            </div>
            <div style={{ backgroundColor: colors.white, height: '100%' }}>
              <Box px={[3]} my={2} w={[1]}>
                <ServiceContainer>
                  {this.state.read !== 3 ? (
                    <Relative>
                      <IconContainer>
                        <AccountCardDetailsIcon
                          style={{ width: '30px', height: '30px' }}
                        />
                      </IconContainer>
                      <ServiceTitle>Audit & accounting</ServiceTitle>
                      <TextSeparator />
                      <ServiceDetails>
                        Statutory and Internal Audit Audit under IFRS, US-GAAP
                        and Indian GAAP and Bookkeeping<br />
                        <br />
                        <br />
                      </ServiceDetails>
                      <Links onClick={() => this.handleread(3)}>
                        {' '}
                        Read More
                      </Links>
                    </Relative>
                  ) : (
                    <Relative>
                      <Box textalign="center">
                        <ServiceDetails style={{ textAlign: 'left' }}>
                          <li>Statutory and Internal Audit</li>
                          <li>Audit under IFRS, US-GAAP and Indian GAAP</li>
                          <li>Bookkeeping (including payroll accounting)</li>
                          <li>IFRS/US-GAAP accounting services</li>
                          <li>
                            Preparation of annual/consolidated financial
                            statements
                          </li>
                        </ServiceDetails>
                        <Links onClick={() => this.handleread(0)}>
                          {' '}
                          Go back
                        </Links>
                      </Box>
                    </Relative>
                  )}
                </ServiceContainer>
              </Box>
            </div>
            <div style={{ backgroundColor: colors.white, height: '100%' }}>
              <Box px={[3]} my={2} w={[1]}>
                <ServiceContainer>
                  {this.state.read !== 4 ? (
                    <Relative>
                      <IconContainer>
                        <CashMultipleIcon
                          style={{ width: '30px', height: '30px' }}
                        />
                      </IconContainer>
                      <ServiceTitle>Guiding & Advisory</ServiceTitle>
                      <TextSeparator />
                      <ServiceDetails>
                        Guiding foreign companies in setting up their business
                        in India<br />
                        <br />
                        <br />
                        <br />
                      </ServiceDetails>
                      <Links onClick={() => this.handleread(4)}>
                        {' '}
                        Read More
                      </Links>
                    </Relative>
                  ) : (
                    <Relative>
                      <Box textalign="center">
                        <ServiceDetails style={{ textAlign: 'left' }}>
                          <li>
                            Guiding foreign companies willing to set up their
                            business in India in the following forms :-
                          </li>
                          <li>100% wholly owned subsidiary</li>
                          <li>Liason office</li>
                          <li> Branch office</li>
                          <li> Project Office</li>
                          <li> Obtaining approvals from RBI</li>
                        </ServiceDetails>
                        <Links onClick={() => this.handleread(0)}>
                          {' '}
                          Go back
                        </Links>
                      </Box>
                    </Relative>
                  )}
                </ServiceContainer>
              </Box>
            </div>
            <div style={{ backgroundColor: colors.white, height: '100%' }}>
              <Box px={[3]} my={2} w={[1]}>
                <ServiceContainer>
                  {this.state.read !== 5 ? (
                    <Relative>
                      <IconContainer>
                        <IncognitoIcon
                          style={{ width: '30px', height: '30px' }}
                        />
                      </IconContainer>
                      <ServiceTitle>Other Services</ServiceTitle>
                      <TextSeparator />
                      <ServiceDetails>
                        Some other services offered by the company are as
                        follows:-<br />
                        <br />
                        <br />
                        <br />
                      </ServiceDetails>
                      <Links onClick={() => this.handleread(5)}>
                        {' '}
                        Read More
                      </Links>
                    </Relative>
                  ) : (
                    <Relative>
                      <Box textalign="center">
                        <ServiceDetails style={{ textAlign: 'left' }}>
                          <li>Payroll Services - ESI & PF</li>
                          <li> Certification Services</li>
                          <li> ROC Complinaces</li>
                          <li> Maintaining Internal Controls</li>
                          <li> Management Consultancy</li>
                        </ServiceDetails>
                        <Links onClick={() => this.handleread(0)}>
                          {' '}
                          Go back
                        </Links>
                      </Box>
                    </Relative>
                  )}
                </ServiceContainer>
              </Box>
            </div>
            <div style={{ backgroundColor: colors.white, height: '100%' }}>
              <Box px={[3]} my={2} w={[1]}>
                <ServiceContainer>
                  {this.state.read !== 6 ? (
                    <Relative>
                      <IconContainer>
                        <AccountCardDetailsIcon
                          style={{ width: '30px', height: '30px' }}
                        />
                      </IconContainer>
                      <ServiceTitle>Financial Advisory Services</ServiceTitle>
                      <TextSeparator />
                      <ServiceDetails>
                        Assistance in evaluation of financial implications of
                        proposed transactions, including tax optimisation<br />
                        <br />
                        <br />
                      </ServiceDetails>
                      <Links onClick={() => this.handleread(6)}>
                        {' '}
                        Read More
                      </Links>
                    </Relative>
                  ) : (
                    <Relative>
                      <Box textalign="center">
                        <ServiceDetails style={{ textAlign: 'left' }}>
                          <li>
                            Assistance in evaluation of financial implications
                            of proposed transactions, including tax optimisation
                            of financing structures
                          </li>
                          <li>Conducting Business Valuations</li>
                          <li>Advice to local/foreign private equity funds</li>
                        </ServiceDetails>
                        <Links onClick={() => this.handleread(0)}>
                          {' '}
                          Go back
                        </Links>
                      </Box>
                    </Relative>
                  )}
                </ServiceContainer>
              </Box>
            </div>
          </Carousel>
        </OnlySmallScreenBox>
      </Box>
    )
  }
}

export default Services



// WEBPACK FOOTER //
// ./src/components/home/Services.js